export default {
  transactionStateLabel: {
    display: "inline-block",
    fontSize: "100%",
    fontWeight: "400",
    lineHeight: "1",
    color: "#fff",
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "baseline",
    borderRadius: ".25em",
    padding: "6px 12px",
    fontSize: "13px",
    lineHeight: "1.42857143",
    minWidth: "120px"
  }
};
